import { FormEvent } from 'react';
import { SearchInput } from '@/app/components/shared/SearchInput';
import { trackSearchEvent } from '@/app/workflows/actions/trackSearchEvent';
import { useWorkflowsCount } from '../../table/query/useWorkflowsQuery';

interface WorkflowSearchUncontrolledProps {
  submitSearch: () => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  clearSearch: () => void;
}

export function WorkflowSearchControlled({
  submitSearch,
  searchTerm,
  setSearchTerm,
  clearSearch,
}: WorkflowSearchUncontrolledProps) {
  const getWorkflowsCount = useWorkflowsCount(searchTerm);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    submitSearch();

    try {
      const resultCount = await getWorkflowsCount();
      if (searchTerm.trim()) {
        try {
          await trackSearchEvent({ keyword: searchTerm.trim(), resultCount });
        } catch (error) {
          console.error('Failed to track search event:', error);
        }
      }
    } catch (error) {
      console.error('Failed to fetch workflows count:', error);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <SearchInput
        name='term'
        placeholder='Search presets'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onClear={clearSearch}
      />
    </form>
  );
}
